import { apiClient } from "../config";

async function archiveOrRestoreMarkerStyle(id: any, status: any) {
  const url = `/admin/marker-style/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreMarkerStyle;
